<template>
  <el-menu :collapse="isExpand" id="Sidebar" background-color="#b22b65" text-color="#fff" active-text-color="#ffd04b" :default-active="$route.path" :unique-opened="false" router >
    <el-menu-item index="/landingPage" >
      <i class="el-icon-s-home" style="color:#fff"></i>
      <span slot="title">首页</span>
    </el-menu-item>
    <el-submenu  index='1'>
      <template slot="title">
        <i class="el-icon-s-order" style="color:#fff"></i>
        <span>参展事项</span>
      </template>
      <el-menu-item index="/timeTable">展会时间表</el-menu-item>
      <el-menu-item>
        <a href="https://www.musicchina-expo.com/#/richtext/canguanzhinan?lan=cn&flag1=3&flag2=1&flag3=-1&action=portal%2FPage%2Findex&param=1808&url=%5Bobject%20Object%5D&t=1720589603511" style="color: #FFFFFF; text-decoration: none;" target="_blank">展览会地点及交通</a>
      </el-menu-item>
      <el-menu-item index="/serve">展馆服务设施</el-menu-item>
      <el-menu-item index="/remittance">汇款及注意事项</el-menu-item>
      <el-menu-item index="/require">有关规定和注意事项</el-menu-item>
      <el-menu-item index="/planView">展馆平面图</el-menu-item>
    </el-submenu>
    <el-submenu  index='2'>
      <template slot="title">
        <i class="el-icon-s-grid" style="color:#fff"></i>
        <span>参展回执表</span>
      </template>
      <!--<el-menu-item index="/magezine" style="line-height: 20px; height: 60px; padding-top: 10px;">会刊登记及展品分类</el-menu-item>-->
      <el-menu-item @click="Goalert" style="line-height: 20px; height: 60px; padding-top: 10px;">会刊登记及展品分类</el-menu-item>
      <el-menu-item index="/card">参展商代表证</el-menu-item>
      <el-menu-item index="/boardInfo">标准展位楣板</el-menu-item>
      <el-menu-item index="/knowledge" style="line-height: 20px; height: 60px; padding-top: 10px;">展览会现场知识产权保护通知</el-menu-item>
      <el-menu-item index="/sound">展台音量规定</el-menu-item>
      <el-menu-item index="/tableDownload">申请表格下载</el-menu-item>
    </el-submenu>
    <el-menu-item index="/advertisement">
      <i class="el-icon-s-management" style="color:#fff"></i>
      <span slot="title">展会广告申请</span>
    </el-menu-item>
    <el-submenu index='4'>
      <template slot="title">
        <i class="el-icon-s-ticket" style="color:#fff"></i>
        <span>网上展览</span>
      </template>
      <el-menu-item index="/onlinemagezine">网上基本信息</el-menu-item>  
      <el-menu-item index="/product">展品速递</el-menu-item>   
    </el-submenu>
    <el-submenu index='7'>
      <template slot="title">
        <i class="el-icon-s-promotion" style="color:#fff"></i>
        <span>搭建指南</span>
      </template>
      <el-menu-item index="/buildingService" style="line-height: 20px; height: 60px; padding-top: 10px;">展会官方合作光地搭建服务商</el-menu-item>
      <el-menu-item index="/buildingGuide">搭建指南下载</el-menu-item>
    </el-submenu>
    <el-submenu index='8'>
      <template slot="title">
        <i class="el-icon-s-custom" style="color:#fff"></i>
        <span>客户邀请</span>
      </template>
      <!--<el-menu-item index="/inviteVIP">VIP观众嘉宾邀请</el-menu-item>-->
      <el-menu-item index="/inviteFree" style="line-height: 20px; height: 60px; padding-top: 10px;">专业观众免费参观证</el-menu-item>
      <el-menu-item index="/inviteCodeEmail" style="line-height: 20px; height: 60px; padding-top: 10px;">短信/邮件一键邀请</el-menu-item>
    </el-submenu>
    <!--<el-menu-item index="/inviteCodeEmail" >
      <i class="el-icon-s-comment" style="color:#fff"></i>
      <span slot="title">邮件邀请</span>
    </el-menu-item>-->
    <el-menu-item index="/hotel">
      <i class="el-icon-s-shop" style="color:#fff"></i>
      <span slot="title">推荐酒店</span>
    </el-menu-item>
    <el-submenu index='6'>
      <template slot="title">
        <i class="el-icon-menu" style="color:#fff"></i>
        <span>其他</span>
      </template>
      <el-menu-item index="/resetPass">修改密码</el-menu-item>  
      <el-menu-item index="/downzssc">展商手册下载</el-menu-item>   
    </el-submenu>
    <!--<el-submenu index='3'>
      <template slot="title"   >
        <div @click="navTozw">
          <i class="el-icon-s-ticket" style="color:#fff"></i>
         <span>我的展位</span>
        </div>
      </template>
      <el-menu-item index="/boardInfo"  >标准展位</el-menu-item>
      <el-menu-item index="/tz">特装展位</el-menu-item>
    </el-submenu>-->

    <!--<el-menu-item index="/activityList"  >
      <i class="el-icon-date" style="color:#fff"></i>
      <span slot="title">同期会议</span>
    </el-menu-item>-->

    <!--<el-submenu index='4'>
      <template slot="title">
        <i class="el-icon-s-ticket" style="color:#fff"></i>
        <span>营销服务</span>
      </template>
      <el-menu-item index="/adBook" >CAC整合营销手册</el-menu-item>  
      <el-menu-item index="/fshow">FSHOW赞助方案</el-menu-item>   
    </el-submenu>-->

    <!-- <el-menu-item index="/lzCode">
      <i class="el-icon-document" style="color:#fff"></i>
      <span slot="title">自助领证码</span>
    </el-menu-item> -->
    <!--<el-menu-item index="/inviteCode">
      <i class="el-icon-postcard" style="color:#fff"></i>
      <span slot="title">企业名片</span>
    </el-menu-item>

    <el-menu-item index="/hotel" >
      <i class="el-icon-date" style="color:#fff"></i>
      <span slot="title">酒店预订</span>
    </el-menu-item>

    <el-menu-item index="/yaoqing" >
      <i class="el-icon-collection" style="color:#fff"></i>
      <span slot="title">邀请函</span>
    </el-menu-item>

    <el-menu-item index="/downCenter" >
      <i class="el-icon-download" style="color:#fff"></i>
      <span slot="title">下载中心</span>
    </el-menu-item>-->

    <!-- <el-menu-item index="/boothBook" >
      <i class="el-icon-date" style="color:#fff"></i>
      <span slot="title">下届展位预定</span>
    </el-menu-item> -->




  </el-menu>
</template>

<script>
import api from '@/api'
export default {
  data() {
    return {
      // currentMenuIndex: this.$route.meta.menuIndex.toString(),
      userInfo: {},
      isShowCode:false,
      mainFunList:{},
      companyMuenList: {},
      ztMuenList: {},
      xkMuenList: {},
      atyMuenList: {},
      lzmMuenList: {},
      cooperaMuenList: {},
      typeStr:"",
      iframeUrl:"",
      demoExcel:'./展台演出申请.pdf'
    }
  },
  created() {
    this.initDashboard()
  },

  mounted() {
    this.getmenulist()
//  this.getUrl()
  },

  watch: {},
  computed: {
    isExpand() {
      return this.$store.state.status.isExpand
    },
    // 控制显示的菜单
    isShowMenu() {
      return function(_arr,str) {
        var _arrList = this[_arr]
        if(_arrList.childs){
          for(var i = 0; i<_arrList.childs.length;i++){
              if( _arrList.childs[i].perName == str){
                return true
              }
          }
          return false
        }else{
          return false
        }
      }
    }
  },
  methods: {
    goLink(){
    // console.log('2323')
      window.location = 'http://online.musicchina-expo.com/'
    },
    Goalert(){
      alert('会刊服务已截止提交，网上展厅以及导览信息请在网上基本信息模块完善。')
    },
    getUrl(){
      api.getdynamicboothmapurl({
        source:"下届",  //下届    本届
        language:"cn"
      }).then(res=>{
        // console.log(res.data)
        if(res.data.code == '200'){
            this.iframeUrl = res.data.data.dynamicUrl || ''
            // console.log('dddddddddddddd')
        }
      })
    },
    getmenulist() {
      api.getmenulist().then(res => {
        if (res.data.code === 200) {
          var menulist = res.data.data
          for(var i=0;i<menulist.length;i++){
            if(menulist[i].perName == '主要功能'){
              this.mainFunList = menulist[i]
            }
            if(menulist[i].perName == '公司信息'){
              this.companyMuenList = menulist[i]
            }
            if(menulist[i].perName == '我的展台'){
              this.ztMuenList = menulist[i]
            }

            if(menulist[i].perName == '胸卡申请'){
              this.xkMuenList = menulist[i]
            }
            if(menulist[i].perName == '自助领证码'){
              this.lzmMuenList = menulist[i]
            }
            if(menulist[i].perName == '活动列表'){
              this.atyMuenList = menulist[i]
            }

            if(menulist[i].perName == '合作服务'){
              this.cooperaMuenList = menulist[i]
            }
          }
        }
      })
    },
    navTozw(){
      if(this.userInfo.bthBigType=='SS'){
          this.$router.push({path:'/boardInfo'})
          // window.location.href = 'https://serv.exporegist.com/nyZfw/#/boardInfo'
        }else{
          this.$router.push({path:'/tz'})
          // window.location.href = 'https://serv.exporegist.com/nyZfw/#/tz'
        }
    },
    navTo(name) {
      if (this.$route.name === name) {
        return false
      }
      this.$router.push(`/${name}`)
    },
    navToLink(link){
      // console.log('eeeeeeeeeeee')
      window.open(this.iframeUrl, '_blank');
      // window.location.href = link,'_blank'
    },
    initDashboard() {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      // this.userInfo.bthCode='1'
      let duration = ''

      if (!this.userInfo) {
        this.$router.push('/login?ExhID='+localStorage.getItem("ExhID"))
        return
      }

      if (this.userInfo.loginTime === '') {
        this.$router.push('/login?ExhID='+localStorage.getItem("ExhID"))
        return
      }
      if( this.userInfo ){

        if(this.userInfo.bthBigType=='SS'){
          this.isShowCode = true
          this.typeStr = '标准展位'
        }else{
          this.typeStr = '特装展位'
        }
          
          
      }
      duration = (new Date().getTime() - this.userInfo.loginTime) / 1000 / 60 / 60
      // 登陆超过20小时后超时
      if (duration > 20) {
        this.$alert('超时，请重新登录', '', {
          confirmButtonText: '确定',
          callback: (action) => {
            localStorage.removeItem('userInfo')
            this.$router.push('/login?ExhID='+localStorage.getItem("ExhID"))
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
#Sidebar {
  padding-top: 60px;
  height: auto;
  &:not(.el-menu--collapse) {
    width: 220px;
  }
  .el-menu-item{
    white-space: normal !important;
  }
}

@media screen and (max-width:540px){
  // #Sidebar {
  //   position: fixed;
  //   z-index: 10
  // }
}
</style>
